// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--_1M76","content":"a10a3f92e9--content--qPlj_","features":"a10a3f92e9--features--k3y0X"};